export const LiberE = {
	"title": "Liber E vel Exercitiorum",
	"subtitle": "sub figura IX",
	"chapters": [
	  {
		"chapter_number": "I",
		"chapter_title": "The Magickal Record",
		"verses": [
		  {
			"verse": 1,
			"text": "It is absolutely necessary that all experiments should be recorded in detail during, or immediately after, their performance.\n"
		  },
		  {
			"verse": 2,
			"text": "It is highly important to note the physical and mental condition of the experimenter or experimenters.\n"
		  },
		  {
			"verse": 3,
			"text": "The time and place of all experiments must be noted; also the state of the weather, and generally all conditions which might conceivably have any result upon the experiment either as adjuvants to or causes of the result, or as inhibiting it, or as sources of error.\n"
		  },
		  {
			"verse": 4,
			"text": "The A.·. A.·. will not take official notice of any experiments which are not thus properly recorded.\n"
		  },
		  {
			"verse": 5,
			"text": "It is not necessary at this stage for us to declare fully the ultimate end of our researches; nor indeed would it be understood by those who have not become proficient in these elementary courses.\n"
		  },
		  {
			"verse": 6,
			"text": "The experimenter is encouraged to use his own intelligence, and not to rely upon any other person or persons, however distinguished, even among ourselves.\n"
		  },
		  {
			"verse": 7,
			"text": "The written record should be intelligently (WEH NOTE: EQUINOX I, 1 has “intelligibly”) prepared so that others may benefit from its study.\n"
		  },
		  {
			"verse": 8,
			"text": "The Book John St. John published in the first number of the 'Equinox' is an example of this kind of record by a very advanced student. It is not as simply written as we could wish, but will show the method.\n"
		  },
		  {
			"verse": 9,
			"text": "The more scientific the record is, the better. Yet the emotions should be noted, as being some of the conditions. Let then the record be written with sincerity and care; thus with practice it will be found more and more to approximate to the ideal.\n"
		  }
		]
	  },
	  {
		"chapter_number": "II",
		"chapter_title": "Physical clairvoyance",
		"verses": [
		  {
			"verse": 1,
			"text": "Take a pack of (78) Tarot playing cards. Shuffle; cut. Draw one card. Without looking at it, try to name it. Write down the card you name, and the actual card. Repeat, and tabulate results.\n"
		  },
		  {
			"verse": 2,
			"text": "This experiment is probably easier with an old genuine pack of Tarot cards, preferably a pack used for divination by someone who really understood the matter.\n"
		  },
		  {
			"verse": 3,
			"text": "Remember that one should expect to name the right card once in 78 times. Also be careful to exclude all possibilities of obtaining the knowledge through the ordinary senses of sight and touch, or even smell. There was once a man whose fingertips were so sensitive that he could feel the shape and position of the pips and so judge the card correctly.\n"
		  },
		  {
			"verse": 4,
			"text": "It is better to try first the easier form of the experiment, by guessing only the suit.\n"
		  },
		  {
			"verse": 5,
			"text": "Remember that in 78 experiments you should obtain 22 trumps and 14 of each other suit; so that without any clairvoyance at all, you can guess right twice in 7 times (roughly) by calling trumps each time.\n"
		  },
		  {
			"verse": 6,
			"text": "Note that some cards are harmonious. Thus it would not be a bad error to call the five of Swords ('The Lord of Defeat') instead of the ten of Swords ('The Lord of Ruin'). But to call the Lord of Love (2 Cups) for the Lord of Strife (5 Wands) would show that you were getting nothing right. Similarly a card ruled by Mars would be harmonious with a 5, a card of Gemini with 'The Lovers'.\n"
		  },
		  {
			"verse": 7,
			"text": "These harmonies must be thoroughly learnt, according to the numerous tables given in 777.\n"
		  },
		  {
			"verse": 8,
			"text": "As you progress you will find that you are able to distinguish the suit correctly three times in four and that very few indeed inharmonious errors occur, while in 78 experiments you are able to name the card aright as many as 15 or 20 times.\n"
		  },
		  {
			"verse": 9,
			"text": "When you have reached this stage, you may be admitted for examination; and in the event of your passing you will be given more complex and difficult exercises.\n"
		  }
		]
	  },
	  {
		"chapter_number": "III",
		"chapter_title": "Asana – Posture",
		"verses": [
		  {
			"verse": 1,
			"text": "You must learn to sit perfectly still with every muscle tense for long periods.\n"
		  },
		  {
			"verse": 2,
			"text": "You must wear no garments that interfere with the posture in any of these experiments.\n"
		  },
		  {
			"verse": 3,
			"text": "The first position: (The God). Sit in a chair; head up, back straight, knees together, hands on knees, eyes closed.\n"
		  },
		  {
			"verse": 4,
			"text": "The second position: (The Dragon). Kneel; buttocks resting on the heels, toes turned back, back and head straight, hands on thighs.\n"
		  },
		  {
			"verse": 5,
			"text": "The third position: (The Ibis). Stand, hold left ankle with right hand, (and alternately practise right ankle in left hand, &c.), free forefinger on lips.\n"
		  },
		  {
			"verse": 6,
			"text": "The fourth position: (The Thunderbolt). Sit; left heel pressing up anus, right foot poised on its toes, the heel covering the phallus; arms stretched out over the knees; head and back straight.\n"
		  },
		  {
			"verse": 7,
			"text": "Various things will happen to you while you are practising these positions; they must be carefully analysed and described.\n"
		  },
		  {
			"verse": 8,
			"text": "Note down the duration of practice; the severity of the pain (if any) which accompanies it, the degree of rigidity attained, and any other pertinent matters.\n"
		  },
		  {
			"verse": 9,
			"text": "When you have progressed up to the point that a saucer filled to the brim with water and poised upon the head does not spill one drop during a whole hour, and when you can no longer perceive the slightest tremor in any muscle; when, in short, you are perfectly steady and easy, you will be admitted for examination; and, should you pass, you will be instructed in more complex and difficult practices.\n"
		  }
		]
	  },
	  {
		"chapter_number": "IV",
		"chapter_title": "Pranayama – Regularisation of the Breathing",
		"verses": [
		  {
			"verse": 1,
			"text": "At rest in one of your positions, close the right nostril with the thumb of the right hand and breathe out slowly and completely through the left nostril, while your watch marks 20 seconds. Breathe in through the same nostril for 10 seconds. Changing hands, repeat with the other nostril. Let this be continuous for one hour.\n"
		  },
		  {
			"verse": 2,
			"text": "When this is quite easy to you, increase the periods to 30 and 15 seconds.\n"
		  },
		  {
			"verse": 3,
			"text": "When this is quite easy to you, but not before, breathe out for 15 seconds, in for 15 seconds, and hold the breath for 15 seconds.\n"
		  },
		  {
			"verse": 4,
			"text": "When you can do this with perfect ease and comfort for a whole hour, practice breathing out for 40 and in for 20 seconds.\n"
		  },
		  {
			"verse": 5,
			"text": "This being attained, practice breathing out for 20, in for 10, holding the breath for 30 seconds.\n"
		  },
		  {
			"verse": 6,
			"text": "When this has become perfectly easy to you, you may be admitted for examination, and should you pass, you will be instructed in more complex and difficult practices.\n"
		  },
		  {
			"verse": 7,
			"text": "You will find that the presence of food in the stomach, even in small quantities, makes the practices very difficult.\n"
		  },
		  {
			"verse": 8,
			"text": "Be very careful never to overstrain your powers; especially never get so short of breath that you are compelled to breathe out jerkily or rapidly.\n"
		  },
		  {
			"verse": 9,
			"text": "Strive after depth, fullness, and regularity of breathing.\n"
		  },
		  {
			"verse": 10,
			"text": "Various remarkable phenomena will very probably occur during these practices. They must be carefully analysed and recorded.\n"
		  }
		]
	  },
	  {
		"chapter_number": "V",
		"chapter_title": "Dharana – Control of Thought",
		"verses": [
		  {
			"verse": 1,
			"text": "Constrain the mind to concentrate itself upon a single simple object imagined. The five tatwas are useful for this purpose; they are: a black oval; a blue disk; a silver crescent; a yellow square; a red triangle.\n"
		  },
		  {
			"verse": 2,
			"text": "Proceed to combinations of simple objects; e.g. a black oval within a yellow square, and so on.\n"
		  },
		  {
			"verse": 3,
			"text": "Proceed to simple moving objects, such as a pendulum swinging, a wheel revolving, etc. Avoid living objects.\n"
		  },
		  {
			"verse": 4,
			"text": "Proceed to combinations of moving objects, e.g. a piston rising and falling while a pendulum is swinging. The relation between the two movements should be varied in different experiments. Or even a system of flywheels, eccentrics, and governor.\n"
		  },
		  {
			"verse": 5,
			"text": "During these practices the mind must be absolutely confined to the object determined upon; no other thought must be allowed to intrude upon the consciousness. The moving systems must be regular and harmonious.\n"
		  },
		  {
			"verse": 6,
			"text": "Note carefully the duration of the experiments, the number and nature of the intruding thoughts, the tendency of the object itself to depart from the course laid out for it, and any other phenomena which may present themselves. Avoid overstrain; this is very important.\n"
		  },
		  {
			"verse": 7,
			"text": "Proceed to imagine living objects; as a man, preferably some man known to, and respected by, yourself.\n"
		  },
		  {
			"verse": 8,
			"text": "In the intervals of these experiments you may try to imagine the objects of the other senses, and to concentrate upon them. For example, try to imagine the taste of chocolate, the smell of roses, the feeling of velvet, the sound of a waterfall or the ticking of a watch.\n"
		  },
		  {
			"verse": 9,
			"text": "Endeavour finally to shut out all objects of any of the senses, and prevent all thoughts arising in your mind. When you feel you have attained some success in these practices, apply for examination, and should you pass, more complex and difficult practices will be prescribed for you.\n"
		  }
		]
	  },
	  {
		"chapter_number": "VI",
		"chapter_title": "Physical limitations",
		"verses": [
		  {
			"verse": 1,
			"text": "It is desirable that you should discover for yourself your physical limitations.\n"
		  },
		  {
			"verse": 2,
			"text": "To this end ascertain for how many hours you can subsist without food or drink before your working capacity is seriously interfered with.\n"
		  },
		  {
			"verse": 3,
			"text": "Ascertain how much alcohol you can take, and what forms of drunkenness assail you.\n"
		  },
		  {
			"verse": 4,
			"text": "Ascertain how far you can walk without once stopping; likewise with dancing, swimming, running, etc.\n"
		  },
		  {
			"verse": 5,
			"text": "Ascertain for how many hours you can do without sleep.\n"
		  },
		  {
			"verse": 6,
			"text": "Test your endurance with various gymnastic exercises, club swinging, and so on.\n"
		  },
		  {
			"verse": 7,
			"text": "Ascertain for how long you can keep silence.\n"
		  },
		  {
			"verse": 8,
			"text": "Investigate any other capacities and aptitudes which may occur to you.\n"
		  },
		  {
			"verse": 9,
			"text": "Let all these things be carefully and conscientiously recorded; for according to your powers will it be demanded of you.\n"
		  }
		]
	  },
	  {
		"chapter_number": "VII",
		"chapter_title": "A Course of Reading",
		"verses": [
		  {
			"verse": 1,
			"text": "The object of most of the foregoing practices will not at first be clear to you; but at least (who will deny it?) they have trained you in determination, accuracy, introspection, and many other qualities which are valuable to all men in their ordinary avocations, so that in no case will your time have been wasted.\n"
		  },
		  {
			"verse": 2,
			"text": "That you may gain some insight into the nature of the Great Work which lies beyond these elementary trifles, however, we should mention that an intelligent person may gather more than a hint of its nature from the following books, which are to be taken as serious and learned contributions to the study of Nature, though not necessarily to be implicitly relied upon: The Yi King (S.B.E. Series, Oxford University Press.), The Tao Teh King (S.B.E. Series.), Tannhauser, by A. Crowley, The Upanishads, The Bhagavad-Gita, The Voice of the Silence, Raja Yoga by Swami Vivekananda, The Shiva Sanhita, The Aphorisms of Patanjali, The Sword of Song, The Book of the Dead, Rituel et Dogme de la Haute Magie, The Book of the Sacred Magic of Abramelin the Mage, The Goetia, The Hathayoga Pradipika, The Spiritual Guide of Molinos, Erdmann's History of Philosophy, The Star in the West (Captain Fuller), The Dhammapada (S.B.E. Series, Oxford University Press), The Questions of King Milinda (S.B.E. Series), 777 vel Prolegomena, etc., Varieties of Religious Experience (James), Kabbala Denudata, Konx Om Pax.\n"
		  },
		  {
			"verse": 3,
			"text": "Careful study of these books will enable the pupil to speak in the language of his master, and facilitate communications with him.\n"
		  },
		  {
			"verse": 4,
			"text": "The pupil should endeavour to discover the fundamental harmony of these very varied works; for this purpose he will find it best to study the most extreme divergencies side by side.\n"
		  },
		  {
			"verse": 5,
			"text": "He may at any time that he wishes apply for examination in this course of reading.\n"
		  },
		  {
			"verse": 6,
			"text": "During the whole of this elementary study and practice he will do wisely to seek out and attach himself to, a master, one competent to correct him and advise him. Nor should he be discouraged by the difficulty of finding such a person.\n"
		  },
		  {
			"verse": 7,
			"text": "Let him further remember that he must in no wise rely upon, or believe in, that master. He must rely entirely upon himself, and credit nothing whatever but that which lies within his own knowledge and experience.\n"
		  },
		  {
			"verse": 8,
			"text": "As in the beginning, so at the end, we here insist upon the vital importance of the written record as the only possible check upon error derived from the various qualities of the experimenter.\n"
		  },
		  {
			"verse": 9,
			"text": "Thus let the work be accomplished duly; yea, let it be accomplished duly. (If any really important or remarkable results should occur, or if any great difficulty presents itself, the A.·. A.·. should be at once informed of the circumstances.)\n"
		  }
		]
	  }
	]
  };
  